<!-- Оношлогоо шинжилгээний төв / Төвийн онцлог -->
<template>
    <div class="lang">
        <div class="info">
            <div class="full-width"><img src="/resource/img/center-bg.jpg" alt="" class="full-width--bg">
                <h3 class="title01">Wellness Center</h3>
                <h4 class="title03">
                    Велнес(Wellness) гэдэг үг нь вел-биин(well-being)
                    болон фитнес(fitness) гэсэн үгсийн утгыг агуулж байдаг
                    бөгөөд бие эрүүл, сэтгэл эрүүл, нийгмийн харилцааны
                    хувьд эрүүл аз жаргалтай амьдралыг илэрхийлдэг.
                    Велнес Эрүүл мэндийг дэмжих төв нь таны эрүүл мэндийг
                    сахин хамгаалах үнэн зөв, найдвартай үйлчилгээ үзүүлж,
                    аз жаргалтай амьдралын тань эрхэм дотны нөхөр байх болно.
                </h4>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">Хувь хүний онцлогт тохирсон багц шинжилгээ</h3>
            <p class="bullet03 depth">Төвийг зорьж ирсэн хүн бүртэй манай координатар ганцаарчлан уулзаж зөвлөлдөнө.</p>
            <p class="bullet03 depth">Интернэтээр болон утсаар захиалга өгсөн бол Хэппи кал(үйлчлүүлэгчтэй утсаар холбогдох) үйлчилгээний тусламжтайгаар хүн тус бүрийн хэрэгцээнд нийцүүлсэн багц шинжилгээг санал болгоно. Сонгоход хялбар, хүн тус
                бүрийн хэрэгцээнд нийцүүлсэн тусгай шинжилгээний багцуудыг гаргасан.</p>
            <p class="bullet03 depth">Ухаалаг систем ашиглан интернэт асуулгын хуудаг бөглүүлж, тухайн хүний гэр бүлийн өвчний түүх, амьдралын хэвшил, өвчний шинж тэмдэг зэргийг нэмэлт шинжилгээ шаардлагатай эсэхийг тодорхойлох болон үзлэг
                шинжилгээний үр дүнг тодорхойлоход ашигладаг.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Хамгийн сүүлийн үеийн тоног төхөөрөмжтэй, арвин туршлагатай эмч мэргэжилтнүүд эрүүл мэндийн нарийн оношилгоо шинжилгээг хийдэг</h3>
            <p class="bullet03 depth">Эрүүл мэндийг дэмжих төвийг хариуцан ажилладаг туршлагатай эмч мэргэжилтнүүд, шуурхай бөгөөд нягт уялдаатай ажилладаг нарийн мэргэжлийн профессоруудтай.</p>
            <p class="bullet03 depth">Компьютер томограф(CT), соронзон резонанс(MRI), эхо, позитрон эмиссийн томограф(PET), ходоодны дуран зэрэг сүүлийн үеийн дэвшилтэт төхөөрөмжөөр тоноглож оношилгоо, шинжилгээний нарийвчлалыг нэмэгдүүлсэн.</p>
            <p class="bullet03 depth">Хорт хавдартай болон хүнд өвчтэй өвчтөнүүдийг Велнес төвийн эмч, координаторууд түргэн шуурхай, зохион байгуулалттайгаар амбула сторитой холбож өгдөг.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Өндөр зэрэглэлийн эрүүл мэндийн оношилгоо, шинжилгээ хийлгэх боломжийг олгоно</h3>
            <p class="bullet03 depth">Оношилгоо, шинжилгээний төвийн цэлгэр өрөө тасалгаа, тохилог тухтай хүлээлгийн танхимуудаар явж үзлэг шинжилгээ хийлгэх нь танд таатай байх болно.</p>
            <p class="bullet03 depth">VIP үйлчлүүлэгчдэд зориулсан тусгай хүлээлгийн өрөө болон буудаллах өрөөтэй болсноор примиум үйлчилгээний үнэ цэнийг улам нэмэгдүүллээ.</p>
        </div>
    </div>
</template>
<script>

    export default {
    }

</script>